import { render, staticRenderFns } from "./dialogForm1.vue?vue&type=template&id=0c8ac896&scoped=true"
import script from "./dialogForm1.vue?vue&type=script&lang=js"
export * from "./dialogForm1.vue?vue&type=script&lang=js"
import style0 from "./dialogForm1.vue?vue&type=style&index=0&id=0c8ac896&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ac896",
  null
  
)

export default component.exports